import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import logger from 'redux-logger'

import settingsReducer, { getInitialState } from '../features/settings';
import messageInfoReducer from '../features/messageInfo';
import filtersReducer from '../features/filters';
import annotationSettingsReducer from '../features/annotationSettings';
import lookupReducer from '../features/lookup';
import modelFiltersReducer from '../features/modelFilters';

import Location from '../core/location';

const loadState = () => {
  try {
    const s = localStorage.getItem('state');
    if (s) {
      const state = JSON.parse(s);
      const projectId = Location.getProjectId();
      if (state.settings && projectId) {
        if (projectId != state.settings.projectId)
          delete state.settings.selectedDataSetId;
        state.settings.projectId = projectId;
      }
      return state;
    }
  } catch {
    // ignore
  }
  return {};
}

const saveState = state => {
  try {
    localStorage.setItem('state', JSON.stringify(state));
  } catch {
    // ignore serialize errors
  }
};

const store = {
  reducer: {
    settings: settingsReducer,
    messageInfo: messageInfoReducer,
    filters: filtersReducer,
    annotationSettings: annotationSettingsReducer,
    lookup: lookupReducer,
    modelFilters: modelFiltersReducer,
  },
  preloadedState: loadState(),
}

if (process.env.NODE_ENV === `development`) {
  store.middleware = [...getDefaultMiddleware({
    immutableCheck: { warnAfter: 500 },
    serializableCheck: { warnAfter: 500 },
  }) /*, logger */];
}

const s = configureStore(store);

s.subscribe(() => {
  const settings = s.getState().settings;

  saveState({
    settings: {
      ...getInitialState(),
      projectId: settings.projectId,
      selectedDataSetId: settings.selectedDataSetId,
      config: { ...getInitialState.config, oauthServer: undefined },
      user: settings.user,
    }
  });
});

export default s;
